import { render, staticRenderFns } from "./Deduccion.vue?vue&type=template&id=48e37f6d&"
import script from "./Deduccion.vue?vue&type=script&lang=js&"
export * from "./Deduccion.vue?vue&type=script&lang=js&"
import style0 from "./Deduccion.vue?vue&type=style&index=0&id=48e37f6d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports